import styled from 'styled-components';
import { Link } from 'gatsby';
import SubmenuArrow from './../../images/menu_collapse.svg';

export const DesktopMenu = styled.ul`
  display: flex;
  list-style-type: none;
  padding-left: 0;
  height: 54px;
  align-items: center;
  @media (max-width: 1030px) {
    display: none;
  }
`;

export const ListItem = styled.li`
  display: flex;
  padding: 0 10px;
`;

export const ExternalLink = styled.a`
  color: ${({ theme }) => theme.colors.light};
  font-weight: bold;
  height: 54px;
  letter-spacing: 1px;
  font-size: 18px;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;

  ${({ submenu }) =>
    submenu &&
    `position: relative;
    ::after {
    content: '';
    display: inline-flex;
    margin-left: 5px;
    width: 16px;
    height: 10px;
    background-image: url(${SubmenuArrow});
    background-size: cover;
    background-repeat: no-repeat;
  }`}
  :hover ~ .submenu {
    visibility: visible;
    opacity: 1;
    display: flex;
  }
`;

export const StyledLink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.textFont}, sans-serif;
  text-transform: uppercase;
  height: 54px;
  letter-spacing: 1px;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.light};
  font-weight: bold;
`;

export const SublinkContainer = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 91px;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 0 30px -10px rgba(0, 0, 0, 0.25);
  display: flex;
  transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;
  font-size: 20px;
  :hover {
    visibility: visible;
    opacity: 1;
    display: flex;
  }
`;

export const Sublink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.textFont}, sans-serif;
  display: flex;
  padding: 20px 16px;
  line-height: 20px;
  font-weight: bold;
  position: relative;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  color: ${({ theme }) => theme.colors.primaryColor};
  background: #fff;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  :hover {
    background-color: ${({ theme }) => theme.colors.primaryColor};
    color: #fff;
  }
`;
